import React from 'react';
import BaseEVerifyUsersReview, { CommonEVerifyUsersReviewProps } from './BaseEVerifyUsersReview';

const ClientEVerifyUsersReview = ({ users, onEditButtonClick }: CommonEVerifyUsersReviewProps): JSX.Element => {
  return (
    <BaseEVerifyUsersReview
      sectionText="Signatory"
      editButtonText="Edit Signatory"
      mouSignatoryField={{
        mouSignatories: users,
      }}
      onEditButtonClick={onEditButtonClick}
    />
  );
};

export default ClientEVerifyUsersReview;
